import subModuleKeys from '@/modules/constants/subModuleKeys';

const ViewEconomyModule = () => import(/* webpackChunkName: "vieweconomy" */ '@/components/modules/economy/ViewEconomyModule.vue');
const ViewEconomyEventDetail = () => import(/* webpackChunkName: "vieweconomydetail" */ '@/components/modules/economy/views/ViewEconomyEventDetail.vue');
const TransactionsModule = () => import(/* webpackChunkName: "transactions" */ '@/components/modules/economy/TransactionsModule.vue');
const SalesStatisticsModule = () => import(/* webpackChunkName: "salesstatistics" */ '@/components/modules/statistics/SalesStatisticsModule.vue');
const ViewEconomyOverview = () => import(/* webpackChunkName: "vieweconomy" */ '@/components/modules/economy/views/ViewEconomyOverview.vue');
const SieExportsModule = () => import(/* webpackChunkName: "sieexports" */ '@/components/modules/reports/SieExportsModule.vue');
const SetOffsModule = () => import(/* webpackChunkName: "setoffs" */ '@/components/modules/reports/SetOffsModule.vue');

const subModules = {
  [subModuleKeys.VIEW_ECONOMY]: {
    component: ViewEconomyModule,
    path: '/economy/view',
    props: { moduleKey: subModuleKeys.VIEW_ECONOMY },
    children: [
      {
        path: '/',
        meta: { key: subModuleKeys.VIEW_ECONOMY },
        name: subModuleKeys.VIEW_ECONOMY,
        component: ViewEconomyOverview,
        props: () => ({ moduleKey: subModuleKeys.VIEW_ECONOMY }),
      },
      {
        path: 'detail/:eventId',
        component: ViewEconomyEventDetail,
        name: subModuleKeys.VIEW_ECONOMY_EVENT_DETAIL,
        meta: { key: subModuleKeys.VIEW_ECONOMY },
        props: (route) => (
          {
            moduleKey: subModuleKeys.VIEW_ECONOMY,
            eventId: parseInt(route.params.eventId, 10),
          }),
      },
    ],
  },
  [subModuleKeys.TRANSACTIONS]: {
    name: subModuleKeys.TRANSACTIONS,
    component: TransactionsModule,
    path: '/economy/transactions',
    props: { moduleKey: subModuleKeys.TRANSACTIONS },
  },
  [subModuleKeys.SALES_STATISTICS]: {
    name: subModuleKeys.SALES_STATISTICS,
    component: SalesStatisticsModule,
    path: '/economy/sales',
    props: { moduleKey: subModuleKeys.SALES_STATISTICS },
  },
  [subModuleKeys.SET_OFFS]: {
    name: subModuleKeys.SET_OFFS,
    component: SetOffsModule,
    path: '/economy/set-offs',
    props: { moduleKey: subModuleKeys.SET_OFFS },
  },
  [subModuleKeys.SIE_EXPORTS]: {
    name: subModuleKeys.SIE_EXPORTS,
    component: SieExportsModule,
    path: '/economy/sieexports',
    props: { moduleKey: subModuleKeys.SIE_EXPORTS },
  },
};

export default subModules;
